import { downloadFileFromBlob } from '_utils/downloadFile';
import BaseService from '_services/rest/base';

class WordService extends BaseService {
  constructor() {
    super();
  }

  getUrl() {
    return `${super.getUrl()}api/word`;
  }

  getWordById(id, params) {
    const level = params.level ? params.level : null;

    return this.request(`${this.getUrl()}/${id}`, { level })
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  deleteWord(id) {
    return this.request(`${this.getUrl()}/${id}`, null, 'delete')
      .catch(err => {
        throw err;
      });
  }

  getWords(params) {
    const skip = params.skip ? params.skip : 0;
    const take = params.take ? params.take : 10;
    const search = params.search ? params.search : null;
    const letter = params.letter ? params.letter : null;
    return this.request(`${this.getUrl()}/all/${skip}/${take}`, { search, letter })
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  save(model) {
    return this.request(`${this.getUrl()}`, model, 'post')
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  importFile(file) {
    const formData = new FormData();
    formData.append('file', file);

    return this.request(`${this.getUrl()}/import`, formData, 'post')
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getListWordsImports(params) {
    const skip = params.skip ? params.skip : 0;
    const take = params.take ? params.take : 10;
    const search = params.search ? params.search : null;

    return this.request(`${this.getUrl()}/imports/history/${skip}/${take}`, { search })
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  exportWords() {
    return this.request(`${this.getUrl()}/export`, null, 'get', { responseType: 'blob' })
      .then(response => {
        const name = `Lista_${new Date().getTime()}.txt`;

        downloadFileFromBlob(response, name);

        return response;
      })
      .catch(err => {
        throw err;
      });
  }
}

export default new WordService();
